import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Modal from '../shared/Modal';
import SVGSuccessCheck from '../../svg/SuccessCheck';
import SVGWarningBang from '../../svg/WarningBang';
import SVGMail from '../../svg/Mail';
import { safeRender } from '../../helpers/util';
import { isOccasion } from '../../helpers/serviceUtil';
import { adminChefName, maskDate, adminClientName } from '../../masks';
import { renderLocation } from '../../helpers/serviceDistrictHelpers.js';

class ServicesEventModal extends React.Component {
  state = {};

  warningBang = (
    <span className="warning-bang">
      <SVGWarningBang />
    </span>
  );
  alertBang = (
    <span className="alert-bang">
      <SVGWarningBang />
    </span>
  );
  successCheck = (
    <span className="success-check">
      <SVGSuccessCheck />
    </span>
  );

  render() {
    const { isOpen, isLoading, closeModal, service, zipMap } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={() => closeModal({ activeService: {} })}
        className="modal service-calendar-event-modal admin-wrapper"
      >
        <div
          className={`service-calendar-event service-calendar-event--${service.service_type}`}
        >
          {this.renderHead(service, zipMap)}
          {this.renderBody(service, isLoading)}
        </div>
      </Modal>
    );
  }

  renderHead(service, zipMap) {
    if (!('client' in service)) return '';
    const { service_type } = service;
    const heading = service_type.replace(/_/g, ' ') || '';

    return (
      <div
        className={`service-calendar-event__head service-calendar-event__head--${service_type}`}
      >
        <div className="service-calendar-event__type">
          <p className="p">{heading}</p>
          <p className="p">{renderLocation(service, zipMap)}</p>
          <p className="p p--bold">{safeRender('name', service)}</p>
        </div>
      </div>
    );
  }

  renderBody(service, isLoading) {
    if (isLoading)
      return (
        <div
          className={`service-calendar-event__body service-calendar-event__body--loading`}
        >
          <p className="p">Loading...</p>
        </div>
      );
    else {
      const { service_type } = service;
      return (
        <div
          className={`service-calendar-event__body service-calendar-event__body--${service_type}`}
        >
          {this.renderDateTimeGroup(service)}
          {this.renderAddressGroup(service)}
          {this.renderClientGroup(service)}
          {this.renderStaffGroup(service)}
          {this.renderMenuGroup(service)}
          {this.renderPortionSizeGroup(service)}
          {this.renderEmailStatus(service)}
          <div className="service-calendar-event__group">
            <Link className="a--blue" to={`/admin/service/${service.id}`}>
              View
            </Link>
          </div>
        </div>
      );
    }
  }

  renderEmailStatus(service) {
    const {
      chef_email_recipients,
      chef_email_sent_at,
      client_email_recipients,
      client_email_sent_at,
    } = service;

    const client =
      client_email_recipients && client_email_sent_at ? (
        <div>
          <p className="p">
            {this.getStatusIndicator('accepted')} Client:{' '}
            {client_email_recipients}
          </p>
          <p className="service-calendar-event-staff__p">
            Sent {maskDate(client_email_sent_at)}
          </p>
        </div>
      ) : (
        <div>
          <div className="p">{this.getStatusIndicator('rejected')} Client: N/A
            <span
              className="btn-icon btn-icon--mail"
              style={{ position: 'relative', top: 6}}
              onClick={() => this.props.openSendDetailsModal('client')}
            >
              <SVGMail />
            </span>
          </div>
          <p className="service-calendar-event-staff__p">Not Sent Yet</p>
        </div>
      );

    const chef =
      chef_email_recipients && chef_email_sent_at ? (
        <div>
          <p className="p">
            {this.getStatusIndicator('accepted')} Chef: {chef_email_recipients}
          </p>
          <p className="service-calendar-event-staff__p">
            Sent {maskDate(chef_email_sent_at)}
          </p>
        </div>
      ) : (
        <div>
          <div className="p">{this.getStatusIndicator('rejected')} Chef: N/A
            <span
              className="btn-icon btn-icon--mail"
              style={{ position: 'relative', top: 6}}
              onClick={() => this.props.openSendDetailsModal('staff')}
            >
              <SVGMail />
            </span>
          </div>
          <p className="service-calendar-event-staff__p">Not Sent Yet</p>
        </div>
      );

    return (
      <div className="service-calendar-event__group">
        <p className="p p--bold">Email Status</p>
        {client}
        {chef}
      </div>
    );
  }

  renderPortionSizeGroup(service) {
    const { service_type, portion_size, guest_number } = service;
    return service_type && isOccasion(service) ? (
      // occasion & marketing occasion
      <div className="service-calendar-event__group">
        <p className="p p--bold">Number of Guests</p>
        <p className="p">{guest_number || 0}</p>
      </div>
    ) : (
      // weekly & custom_weekly
      <div className="service-calendar-event__group">
        <p className="p p--bold">Portion Size</p>
        <p className="p --capitalize">{portion_size}</p>
      </div>
    );
  }

  renderMenuGroup(service) {
    const { menu_selections, grocery_list } = service;
    const quantity = menu_selections
      ? menu_selections.reduce(this.reduceQuantity, 0)
      : 0;
    const groceryListStatus =
      grocery_list && grocery_list.approved ? (
        <p className="p">{this.successCheck} Grocery list Approved</p>
      ) : (
        <p className="p">{this.warningBang} Grocery list Not Approved</p>
      );
    const quantityStatus = (
      <p className="p">
        {quantity > 0 ? this.successCheck : this.warningBang} {quantity} Dishes
        Selected
      </p>
    );
    return (
      <div className="service-calendar-event__group">
        <p className="p p--bold">Menu</p>
        {quantityStatus}
        {groceryListStatus}
      </div>
    );
  }

  renderClientGroup(service) {
    const { client } = service;
    return (
      <div className="service-calendar-event__group">
        <p className="p p--bold">Client</p>
        {client && (
          <Link
            className="a--black"
            target="_blank"
            to={`/admin/client/${client.id}`}
          >
            {adminClientName(client)}
          </Link>
        )}
      </div>
    );
  }

  renderStaffGroup(service) {
    const { invited_chefs } = service;
    const chefs =
      invited_chefs && invited_chefs.length ? (
        // has staff
        invited_chefs.map(({ status, chef, role, invite_last_sent }, key) => (
          <div key={key} className={status}>
            {status !== 'rejected' && (
              <p className="p">
                {this.getStatusIndicator(status)}{' '}
                { adminChefName(chef) }
                {role ? ` - ${role}` : ''}
              </p>
            )}

            {status !== 'accepted' && invite_last_sent && (
              <p className="service-calendar-event-staff__p">
                Sent {maskDate(invite_last_sent)}
              </p>
            )}
          </div>
        ))
      ) : (
        // no staff
        <p className="p">No Staff</p>
      );
    return (
      <div className="service-calendar-event__group">
        <p className="p p--bold">Staff</p>
        {chefs}
      </div>
    );
  }

  renderDateTimeGroup(service) {
    const { start_time, end_time, date } = service;
    return (
      <div className="service-calendar-event__group">
        <p className="p p--bold">Date & Time</p>
        <p className="p">{this.formatDate(date)}</p>
        <p className="p">{this.formatStartAndEnd(start_time, end_time)}</p>
      </div>
    );
  }

  renderAddressGroup(service) {
    const { address } = service;
    return (
      <div className="service-calendar-event__group">
        <p className="p p--bold">Service Address</p>
        <p className="p">
          {`${safeRender('street_address', address)}, ${safeRender(
            'city',
            address
          )}, ${safeRender('state', address)} ${safeRender(
            'zip_code',
            address
          )}`}
        </p>
      </div>
    );
  }

  getStatusIndicator(status) {
    switch (status) {
      case 'rejected':
        return this.warningBang;
      case 'accepted':
        return this.successCheck;
      case 'pending':
        return this.alertBang;
      default:
        return this.alertBang;
    }
  }

  reduceQuantity = (total, { quantity }) => total + quantity;

  formatDate(date) {
    if (!date) return '';
    return moment(date).format('dddd, MMMM D');
  }

  formatStartAndEnd(start, end) {
    return `${moment(start).format(`h[:]mma`)} - ${moment(end).format(
      `h[:]mma`
    )}`;
  }
}

export default ServicesEventModal;



// WEBPACK FOOTER //
// ./src/components/services/ServicesEventModal.js